import { DeltaIndicatorType } from "../../components/delta-indicator-chip";

interface ContentElementProps {
  prefix?: string;
  content: string | number;
  delta?: { type: DeltaIndicatorType; value: string };
}

export default function ContentElement({
  content,
  delta,
  prefix,
}: ContentElementProps) {
  const contentAsFormattedNumber =
    typeof content === "number"
      ? Number(content).toLocaleString("en-IN", {
          maximumFractionDigits: 2,
        })
      : content;

  const textContent = prefix
    ? `${prefix} ${contentAsFormattedNumber}`
    : contentAsFormattedNumber;

  return (
    <>
      <span className="mr-2">{textContent}</span>
    </>
  );
}
